import React, { Component } from "react"

import { HeadingInitial, HeadingSecondary, Paragraph, Section } from "elements"

class Value extends Component {
  render() {
    return (
      <div>
        <HeadingInitial>Our Value to Camps</HeadingInitial>

        <Section>
          <HeadingSecondary>It’s About Quantity and Quality</HeadingSecondary>
          <Paragraph>
            Your camp already has its own webpage. If so, then you’ve already
            learned that the early Web adage “If you build it, they will come”
            does not hold true today. With millions of web sites online
            competing for attention, we now realize that company or individual
            homepages need additional advertising to attract users. Camps and
            Campers can help bring attention to your camp. We aggressively
            advertise nationwide via blogs, social media and traditional media.
            Acting as a clearinghouse for camp openings, Camps and Campers
            attracts families interested in new summer camps and can offer them
            a link to your more comprehensive Web site. We are another vital
            tool in your advertising campaign.
          </Paragraph>
        </Section>

        <Section>
          <HeadingSecondary>The Last Word: Efficiency</HeadingSecondary>
          <Paragraph>
            Placing expensive ads requires a certain gamble on your part with
            regard to who will see them. But with Camps and Campers, we’re doing
            the leg work for you, bringing qualified and interested campers to
            our site.
          </Paragraph>
          <Paragraph>
            We do more than find them. We also automate the filtering process
            for you. When people contact you through Camps and Campers, they
            already know a lot about your camp, and your openings. When you’re
            conducting the search, you separate the wheat from the chaff by
            simply reading family profiles. No unnecessary expenditure of time
            or money, and no following dead-end leads.
          </Paragraph>
        </Section>
      </div>
    )
  }
}

export default Value



// WEBPACK FOOTER //
// ./src/scenes/About/pages/value.js